import './load-apollodev';
import React from 'react';
import ReactDOM from 'react-dom';
import { createGlobalStyle } from 'styled-components';
import Root from './Root';
import { Tawk } from './providers';

import styles from './styles';

Tawk.initializeTawk();

const GlobalStyle = createGlobalStyle`
    ${styles.fontFace}

    #root {
        height: 100%;
    }
`;

ReactDOM.render(
    <React.Fragment>
        <GlobalStyle />
        <Root />
    </React.Fragment>,
    document.getElementById('root')
);

